import {
  BenefitCard,
  HeroStat,
  MemberTab,
  ProcessStep
} from './forClubsLandingContent.model'

export const FOR_CLUBS_SECTION_FOOTER_GAP_PX = 100

export const SIMPLE_PROCESS_CARD_HEIGHT = 805
export const SIMPLE_PROCESS_TEXT_BLOCK_HEIGHT = 280
export const SIMPLE_PROCESS_IMAGE_HEIGHT = 580

export const HERO_STATS: HeroStat[] = [
  { value: '40+', top: 'Clubs on', bottom: 'Platform' },
  { value: '50k+', top: 'Registered', bottom: 'Fans' },
  { value: '20+', top: 'Countries' },
  { value: '$0', top: 'Costs to', bottom: 'Join' }
]

export const PROCESS_STEPS: ProcessStep[] = [
  {
    title: 'Register Your Club',
    description:
      'Fill out a simple registration form with your club details. Our team reviews and verifies your application within 48 hours. Completely free.'
  },
  {
    title: 'Your Fans Join Arena',
    description:
      'Your fans register on Arena and choose your club. They join your digital community, compete for your ranking, and bring real value.',
    invert: true
  },
  {
    title: 'Fans Complete Brand Tasks',
    description:
      'Global brands post tasks — reposts, videos, reviews. Your fans complete them, generating organic reach. Arena tracks all activity automatically.'
  },
  {
    title: 'Club Earns Real Revenue',
    description:
      'For every Arena Point earned by your fans, your club accumulates points too. Arena Points are tracked in your club dashboard in real time.',
    invert: true
  }
]

export const BENEFITS = [
  'Brand Partnerships|Arena connects your club with global brands',
  'Club Leaderboard|Compete with other clubs globally. Top clubs get featured placement',
  'Fan Analytics Dashboard|Access detailed data on your fanbase - all in one dashboard',
  'Global Fan Discovery|Your club gets discovered by fans worldwide',
  'Organic Growth Engine|Fans promote your club through brand tasks',
  'Zero Upfront Cost|Registration is free. No fees, no commitments. You earn from day one'
] as const

export const SIMPLE_PROCESS_TRANSLATION_KEYS = [
  { titleKey: 'processStep1Title1', descriptionKey: 'processStep1' },
  { titleKey: 'processStep2Title1', descriptionKey: 'processStep2' },
  { titleKey: 'processStep3Title1', descriptionKey: 'processStep3' },
  { titleKey: 'processStep4Title1', descriptionKey: 'processStep4' }
] as const

export const benefitCards: BenefitCard[] = [
  {
    id: '1',
    textPosition: 'top',
    imageHeight: SIMPLE_PROCESS_IMAGE_HEIGHT,
    imageUrl: '/assets/drift.webp'
  },
  {
    id: '2',
    textPosition: 'bottom',
    imageHeight: SIMPLE_PROCESS_IMAGE_HEIGHT
  },
  {
    id: '3',
    textPosition: 'top',
    imageHeight: SIMPLE_PROCESS_IMAGE_HEIGHT
  },
  {
    id: '4',
    textPosition: 'bottom',
    imageHeight: SIMPLE_PROCESS_IMAGE_HEIGHT
  }
]
export const CLUB_LOGO = '/assets/forClubs/club-logo.png'
export const BALL_IMAGE = '/assets/forClubs/case-study-ball-base.png'
export const STORY_BG = '/assets/forClubs/story-bg.png'

export const MEMBER_TABS: MemberTab[] = [
  { value: 'all', labelKey: 'tabs.all' },
  { value: 'football', labelKey: 'tabs.football' },
  {
    value: 'drift',
    labelKey: 'tabs.drift',
    isDisabled: true,
    hasSoonBadge: true
  },
  {
    value: 'basketball',
    labelKey: 'tabs.basketball',
    isDisabled: true,
    hasSoonBadge: true
  },
  {
    value: 'americanFootball',
    labelKey: 'tabs.americanFootball',
    isDisabled: true,
    hasSoonBadge: true
  }
]

export const DEFAULT_CLUB_LOGO = '/assets/default-avatar.svg'

export const STADIUM_FANS_IMG = '/assets/stadium-fans.webp'
export const CLUBS_EMAIL = 'clubs@bcsarena.io'

export const CLUBS_SUPPORT_EMAIL = 'support@bcsarena.io'
